<template>
  <transition name="fade">
    <div class="overlay" v-if="show">
      <div class="overlay__inner">
        <div class="panel activation-confirm-modal">
          <div class="panel__header">
            <h3>Confirm App Activation Request</h3>
            <span class="overlay__close" @click="$emit('close')">
              <i class="fas fa-times"></i>
            </span>
          </div>
          <div class="panel__content">
            <p>You're ready to activate the new Visceral Consignment app! This will notify our team that you approve the activation, and we'll complete the process for you.</p>

            <div class="confirmation-checkbox">
              <label>
                <input type="checkbox" v-model="confirmationChecked">
                I understand and approve the new app activation
              </label>
            </div>

            <div class="modal-actions">
              <button class="btn-secondary" @click="$emit('close')">Cancel</button>
              <button
                class="btn-primary"
                :class="{ disabled: !confirmationChecked }"
                :disabled="!confirmationChecked"
                @click="confirmActivation">
                Submit Approval
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ActivationConfirmModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      confirmationChecked: false
    }
  },
  methods: {
    confirmActivation () {
      if (this.confirmationChecked) {
        this.$emit('confirm')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.activation-confirm-modal {

  .confirmation-checkbox {
    margin: 20px 0;

    label {
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
    }
  }

  .modal-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 20px;
  }

  .btn-primary, .btn-secondary {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .btn-primary {
    background: var(--primary-color, #eb008c);
    color: white;
  }

  .btn-secondary {
    background: #ccc;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/components/ActivationConfirmModal.vue